export default function PageLoader({
  label,
  className = '',
  minHeightClass = 'min-h-screen',
}) {
  const resolvedLabel = label || 'Loading...';

  return (
    <div
      className={`flex ${minHeightClass} items-center justify-center bg-[var(--dash-blacker)] px-6 text-white ${className}`.trim()}
    >
      <div className="flex flex-col items-center gap-4 text-center">
        <div className="h-12 w-12 animate-spin rounded-full border-2 border-[var(--dash-border)] border-t-[var(--dash-primary)]" />
        <p className="text-xs font-bold uppercase tracking-[0.24em] text-white/50">{resolvedLabel}</p>
      </div>
    </div>
  );
}
